import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';
import SectionHeader from '@/components/feature/SectionHeader';
import { testimonials, stats, contactInfo, faqs } from '@/mocks/siteData';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="BreadcrumbList" />
      <SchemaOrg type="FAQPage" data={{ faqs }} />

      <main className="pt-20 md:pt-24">
        {/* Breadcrumb */}
        <div className="w-full px-4 md:px-6 py-4">
          <div className="max-w-7xl mx-auto">
            <nav className="flex items-center gap-1.5 text-xs text-foreground-500" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors duration-200">
                首页
              </Link>
              <i className="ri-arrow-right-s-line text-sm"></i>
              <span className="text-foreground-200">关于我们</span>
            </nav>
          </div>
        </div>

        {/* Brand Intro */}
        <section className="w-full px-4 md:px-6 py-8 md:py-14">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10">
              <div className="w-16 h-16 flex items-center justify-center bg-primary-500 rounded-xl mx-auto mb-5">
                <i className="ri-movie-2-fill text-background-50 text-2xl"></i>
              </div>
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-4">
                关于88影视网
              </h1>
              <p className="text-sm text-foreground-500 leading-relaxed max-w-2xl mx-auto">
                88影视网成立于2020年，致力于为广大影迷提供高清影视在线观看服务。平台涵盖高清电影电视剧、超清影视播放等丰富内容，以高清不卡顿的极致观影体验赢得了数千万用户的信赖与好评。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
              <div className="p-6 bg-background-100 rounded-xl border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 mx-auto mb-4">
                  <i className="ri-eye-line text-xl"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-100 mb-2">我们的愿景</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  成为全球领先的中文高清视频网站，让每一位用户都能享受高清不卡顿的影视观看体验。
                </p>
              </div>
              <div className="p-6 bg-background-100 rounded-xl border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-500/10 text-accent-500 mx-auto mb-4">
                  <i className="ri-shield-check-line text-xl"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-100 mb-2">我们的使命</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  以技术驱动观影体验升级，为用户提供高清电影电视剧在线观看服务，超清影视播放不模糊。
                </p>
              </div>
              <div className="p-6 bg-background-100 rounded-xl border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-500/10 text-accent-500 mx-auto mb-4">
                  <i className="ri-heart-line text-xl"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-100 mb-2">我们的价值观</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  用户至上、品质为先、持续创新。88影视网始终坚持以用户需求为核心，不断优化产品与服务。
                </p>
              </div>
            </div>

            <div className="bg-background-100 rounded-xl border border-background-200/70 p-6 md:p-8">
              <h2 className="text-lg font-heading font-bold text-foreground-50 mb-4">品牌故事</h2>
              <div className="text-sm text-foreground-400 leading-relaxed space-y-4">
                <p>
                  88影视网的创始团队由一群热爱影视的互联网从业者组成。在多年的观影体验中，我们发现用户在寻找高清影视资源时常面临画质模糊、播放卡顿、资源散乱等痛点。为此，我们决心打造一个专注于高清影视在线观看的平台。
                </p>
                <p>
                  自2020年创立以来，88影视网始终坚持<strong>「高清不卡顿」</strong>的核心产品理念。我们投入大量资源建设了覆盖全国的CDN加速网络，确保无论用户在哪个地区，都能享受到流畅的高清在线观看体验。同时，我们建立了完善的内容更新机制，确保最新影视资源能在第一时间上线。
                </p>
                <p>
                  经过数年的发展，88影视网已积累了超过<strong>10000部</strong>高清影视资源，涵盖电影、电视剧、动漫、综艺、纪录片等多个品类。平台月活跃用户突破<strong>500万</strong>，日均播放量超过<strong>2000万次</strong>，成为中文互联网最具影响力的高清视频网站之一。
                </p>
                <p>
                  展望未来，88影视网将继续秉承以用户为中心的理念，持续加大技术研发投入，不断丰富内容资源库，为广大影视爱好者提供更加优质的高清影视在线观看服务。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="w-full px-4 md:px-6 py-8 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <SectionHeader
              title="平台数据"
              subtitle="88影视网运营数据一览"
            />
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center p-5 bg-background-50 rounded-xl border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 mx-auto mb-3">
                    <i className={`${stat.icon} text-lg`}></i>
                  </div>
                  <div className="text-xl md:text-2xl font-bold text-foreground-50 mb-1">{stat.value}</div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-4xl mx-auto">
            <SectionHeader
              title="用户口碑"
              subtitle="来自真实用户的评价与信赖"
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {testimonials.map((t) => (
                <div key={t.id} className="p-5 bg-background-100 rounded-xl border border-background-200/70">
                  <div className="flex items-center gap-3 mb-3">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <div className="text-sm font-medium text-foreground-100">{t.name}</div>
                      <div className="flex items-center gap-0.5 mt-0.5">
                        {Array.from({ length: t.rating }).map((_, i) => (
                          <i key={i} className="ri-star-fill text-[10px] text-primary-500"></i>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-400 leading-relaxed">{t.content}</p>
                  <div className="text-xs text-foreground-600 mt-3">{t.date}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <SectionHeader
              title="联系我们"
              subtitle="如有任何问题或合作意向，欢迎通过以下方式与我们取得联系"
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="flex items-start gap-4 p-5 bg-background-50 rounded-xl border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 shrink-0">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-100 mb-1">电子邮箱</div>
                  <div className="text-sm text-foreground-500">{contactInfo.email}</div>
                </div>
              </div>
              <div className="flex items-start gap-4 p-5 bg-background-50 rounded-xl border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 shrink-0">
                  <i className="ri-phone-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-100 mb-1">客服电话</div>
                  <div className="text-sm text-foreground-500">{contactInfo.phone}</div>
                </div>
              </div>
              <div className="flex items-start gap-4 p-5 bg-background-50 rounded-xl border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 shrink-0">
                  <i className="ri-map-pin-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-100 mb-1">公司地址</div>
                  <div className="text-sm text-foreground-500">{contactInfo.address}</div>
                </div>
              </div>
              <div className="flex items-start gap-4 p-5 bg-background-50 rounded-xl border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 shrink-0">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-100 mb-1">微信公众号</div>
                  <div className="text-sm text-foreground-500">{contactInfo.wechat}</div>
                </div>
              </div>
              <div className="flex items-start gap-4 p-5 bg-background-50 rounded-xl border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 shrink-0">
                  <i className="ri-weibo-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-100 mb-1">官方微博</div>
                  <div className="text-sm text-foreground-500">{contactInfo.weibo}</div>
                </div>
              </div>
              <div className="flex items-start gap-4 p-5 bg-background-50 rounded-xl border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 shrink-0">
                  <i className="ri-time-line text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-100 mb-1">工作时间</div>
                  <div className="text-sm text-foreground-500">{contactInfo.workingHours}</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-4xl mx-auto">
            <SectionHeader
              title="常见问题"
              subtitle="关于88影视网高清在线观看的常见疑问"
            />
            <div className="space-y-3">
              {faqs.map((faq, index) => (
                <details
                  key={index}
                  className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer"
                >
                  <summary className="flex items-center justify-between px-5 py-4 text-sm font-medium text-foreground-100 list-none">
                    <span>{faq.question}</span>
                    <i className="ri-arrow-down-s-line text-lg text-foreground-500 group-open:rotate-180 transition-transform duration-200"></i>
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">
                    {faq.answer}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <BackToTop />
    </>
  );
}